<template>
    <v-flex xs12 style="margin: 3%;">
         <h4 :class='$style.title'><str index="site_regulation > security_1" /></h4>
        <p :class='$style.subTitle'><str index="site_regulation > security_1_text" /></p>
    </v-flex>
</template>

<script>

export default {
    name: "Security",
    components: {

    },
    data: function(){
        return {}
    },
    methods: {},
    computed: {}
}
</script>

<style module>
.title{
    font-size:20px;
    color:rgb(55, 168, 206);
    font-weight:400;
    font-family: roboto, arial;
}

.subTitle{
    font-size:14px;
    font-family: roboto, arial, sans-seri;
    letter-spacing: 0.2px;
    line-height: 24px;
}

@media only screen and (max-width: 425px) {
    .title{
        font-size:14px;
    }

    .subTitle{
        font-size:12px;
    }
}
</style>

<style>

</style>